import {Box, IconButton, Typography, useTheme} from '@mui/material';
import {SidePopupProps} from '../index';
import {Image} from '@jobseeker/lotus/components/Image';
import Slide from '@mui/material/Slide';
import {WhiteCrossOutlined} from '@jobseeker/lotus/icons';

export default ({sx, imgUrl, show, ...props}: SidePopupProps) => {
  const theme = useTheme();
  return (
    <Slide direction="up" in={show} mountOnEnter unmountOnExit>
      <Box
        position={'fixed'}
        // height={'50vh'}
        sx={{
          background: '#fff',
          // border: '1px solid',
          minWidth: '360px',
          border: '1.66px solid #7E7E7E33',
          borderRadius: '16px 16px 0 0',
          overflow: 'hidden',
          right: theme.spacing(1.5),
          bottom: 0,
          zIndex: '900',
          ...sx,
        }}
        {...props}
      >
        <Box
          sx={{
            background: 'linear-gradient(90deg, #225448 0%, #7E9F67 100%)',
            py: 1.5,
            pl: 2,
            pr: 1,
          }}
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          {imgUrl && <Image src={imgUrl} alt={''} />}
          {props.title && <Typography>{props.title}</Typography>}
          <IconButton onClick={props.onClose ? props.onClose : console.log}>
            <Image src={WhiteCrossOutlined} alt={''} />
          </IconButton>
        </Box>
        <Box>{props.children}</Box>
      </Box>
    </Slide>
  );
};
